import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'About', to: '/about' },
  { label: 'Location', to: '/location' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
        scrolled
          ? 'bg-[#080808]/96 backdrop-blur-xl border-b border-white/5'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-6 md:px-12 lg:px-16 h-[76px]">
        {/* Logo */}
        <Link to="/" className="flex items-center flex-shrink-0 group">
          <div className="h-12 w-auto flex items-center justify-center px-1">
            <img
              src="https://storage.readdy-site.link/project_files/82e9787f-6415-42b8-9e52-be199507ad35/9d32c3ec-5bd9-44db-846d-88737afb6501_tint-logo.png?v=b83d4aede8a9172bf74b854a908d18e4"
              alt="TINTSPRO X Logo"
              className="h-full w-auto object-contain transition-opacity duration-300 group-hover:opacity-90"
              style={{ maxWidth: '180px' }}
            />
          </div>
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                className={`text-[13px] font-sans font-medium tracking-wide transition-colors duration-200 hover:text-[#AAFF00] whitespace-nowrap ${
                  pathname === link.to ? 'text-[#AAFF00]' : 'text-white/60'
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Desktop Right */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel:2155949404"
            className="flex items-center gap-2 text-white/55 text-[13px] font-sans hover:text-[#AAFF00] transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-[#AAFF00] text-sm"></i>
            </div>
            (215) 594-9404
          </a>
          <a
            href="#estimate"
            className="whitespace-nowrap flex items-center gap-2 bg-[#AAFF00] text-[#080808] text-[13px] font-sans font-semibold px-5 py-2.5 rounded-full hover:bg-[#C4FF33] transition-all duration-200 cursor-pointer"
          >
            Get a Quote
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </a>
        </div>

        {/* Mobile Controls */}
        <div className="md:hidden flex items-center gap-3">
          <a
            href="tel:2155949404"
            className="flex items-center justify-center w-10 h-10 rounded-full border border-[#AAFF00]/30 text-[#AAFF00] hover:bg-[#AAFF00]/10 transition-colors cursor-pointer"
            aria-label="Call us"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-base"></i>
            </div>
          </a>
          <button
            className="flex items-center justify-center w-10 h-10 text-white cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
            </div>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#080808]/98 backdrop-blur-xl border-t border-white/8 px-6 pt-6 pb-8">
          <ul className="flex flex-col gap-1 mb-6">
            {navLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className={`block py-3 text-base font-sans font-medium border-b border-white/5 transition-colors ${
                    pathname === link.to ? 'text-[#AAFF00]' : 'text-white/70'
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="flex flex-col gap-3">
            <a
              href="tel:2155949404"
              className="flex items-center justify-center gap-2 border border-white/15 text-white text-sm font-sans py-3 rounded-full cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-[#AAFF00] text-sm"></i>
              </div>
              Call (215) 594-9404
            </a>
            <a
              href="#estimate"
              className="flex items-center justify-center gap-2 bg-[#AAFF00] text-[#080808] text-sm font-sans font-semibold py-3.5 rounded-full cursor-pointer"
            >
              Get a Free Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
